<template>
  <div>
    <div>
      <!-- Gender Input -->
      <div class="col form-group mt-3">
        <label
          class="mb-1"
          :style="
            template.secondaryTheme
              ? 'color: white !important; margin-bottom:5px; font-weight: light !important;'
              : ''
          "
        >
          {{ translation.genderIdentity }}
        </label>

        <div class="gender-div-gap">
          <div class="gender-div">
            <input
              id="masculino"
              v-model="obj.gender"
              class="form-check-input"
              style="margin-bottom: 5px"
              type="radio"
              name="gender"
              value="M"
            />
            <label
              for="masculino"
              class="gender-label"
              :style="
                template.secondaryTheme
                  ? 'color: white !important; font-weight: light !important;'
                  : ''
              "
            >
              {{ translation.male }}
            </label>
          </div>

          <div class="gender-div">
            <input
              id="feminino"
              v-model="obj.gender"
              class="form-check-input"
              type="radio"
              name="gender"
              value="F"
            />
            <label
              for="feminino"
              class="gender-label"
              :style="
                template.secondaryTheme
                  ? 'color: white !important; font-weight: light !important;'
                  : ''
              "
            >
              {{ translation.female }}
            </label>
          </div>

          <div class="gender-div">
            <input
              id="outro"
              v-model="obj.gender"
              class="form-check-input"
              type="radio"
              name="gender"
              value="N"
            />
            <label
              for="outro"
              class="gender-label"
              :style="
                template.secondaryTheme
                  ? 'color: white !important; font-weight: light !important;'
                  : ''
              "
            >
              {{ translation.other }}
            </label>
          </div>
        </div>
      </div>

      <!-- Birth Date Input -->
      <div class="col form-group mt-3">
        <input
          v-model="obj.birthDate"
          v-mask="'##/##/####'"
          class="w-100"
          :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
          :placeholder="translation.birthDate"
          @keyup.enter="validateFields"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* State */
import { mapState, mapMutations } from 'vuex'

/* Helpers */
import { mask } from 'vue-the-mask'

export default {
  name: 'GenderAndBirthDate',
  props: {
    validate: Boolean,
  },
  mask: {
    ...mask,
    tokens: {
      ...mask.tokens,
      null: /./,
    },
  },
  data: () => ({
    obj: {},
    key: 0,
    toastMessage: '',
  }),
  computed: {
    ...mapState(['config', 'registrationObject', 'subdomain', 'template']),
    translation() {
      return {
        attention: this.$t('common.attention'),
        genderIdentity: this.$t('gender.identity'),
        male: this.$t('gender.male'),
        female: this.$t('gender.female'),
        other: this.$t('gender.other'),
        birthDate: this.$t('birthDate.placeholder'),
        alertGender: this.$t('gender.required'),
        alertBirthDate: this.$t('birthDate.required'),
        alertValidDate: this.$t('birthDate.invalid'),
        alertMinimumAgeToAccount: this.$t('birthDate.minimumAge', {
          age: this.config.minimumAgeToAccount,
        }),
      }
    },
  },
  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
  mounted() {
    // Creates a deep copy of the object in the store
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))

    if (!this.obj.gender) this.obj.gender = 'g'
  },
  methods: {
    ...mapMutations([
      'updateRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
    ]),
    makeToast(variant = null) {
      this.$bvToast.toast(this.toastMessage, {
        title: this.translation.attention,
        variant: variant,
        solid: true,
      })
    },
    validateBirthDate(dateStr, clientMinimumAge = 0) {
      // First check for the pattern
      if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateStr)) return false

      // Parse the date parts to integers
      let parts = dateStr.split('/')

      let day = parseInt(parts[0], 10)
      let month = parseInt(parts[1], 10)
      let year = parseInt(parts[2], 10)

      // Check the ranges of month and year
      if (year < 1000 || year > 3000 || month == 0 || month > 12) return false

      const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

      // Adjust for leap years
      if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
        monthLength[1] = 29
      }

      // Check the range of the day
      if (day <= 0 || day > monthLength[month - 1]) return false

      // Convert the input date to a Date object
      const inputDate = new Date(year, month - 1, day)
      const today = new Date()

      // Calculate the maximum birthdate (150 years ago)
      const maxBirthDate = new Date(today)
      maxBirthDate.setFullYear(today.getFullYear() - 150)

      // Calculate the minimum birthdate based on the client age configuration
      const minBirthDate = new Date(today)
      if (clientMinimumAge > 0) {
        minBirthDate.setFullYear(today.getFullYear() - clientMinimumAge)
      }

      // Validate that the input date is within the allowed range
      if (inputDate < maxBirthDate || inputDate > minBirthDate) {
        return false
      }

      return true
    },
    validateFields() {
      this.$emit('validating')

      this.clearRegistrationErrors()

      let hasErrors = false

      if (!this.obj.gender || this.obj.gender === 'g') {
        hasErrors = true

        this.addRegistrationError({
          msg: this.translation.alertGender,
        })
        this.toastMessage = this.translation.alertGender
        this.makeToast('warning')
      }

      if (!this.obj.birthDate || this.obj.birthDate.length < 10) {
        hasErrors = true

        this.addRegistrationError({
          msg: this.translation.alertBirthDate,
        })
        this.toastMessage = this.translation.alertBirthDate
        this.makeToast('warning')
      }

      const hasSearchUserStep =
        this.config.registrationSteps && this.config.registrationSteps.includes('SearchUser')
      const mustValidateMinimumAge = !hasSearchUserStep
      const isDateValid = this.validateBirthDate(this.obj.birthDate, 0)
      const meetsMinimumAge = this.validateBirthDate(
        this.obj.birthDate,
        this.config.minimumAgeToAccount,
      )

      if (!isDateValid) {
        hasErrors = true
        this.addRegistrationError({
          msg: this.translation.alertValidDate,
        })
        this.toastMessage = this.translation.alertValidDate
        this.makeToast('warning')
      } else if (mustValidateMinimumAge && !meetsMinimumAge) {
        hasErrors = true
        if (this.config.minimumAgeToAccount != undefined) {
          this.addRegistrationError({
            msg: this.translation.alertMinimumAgeToAccount,
          })
          this.toastMessage = this.translation.alertMinimumAgeToAccount
          this.makeToast('warning')
        }
      }

      if (!hasErrors) {
        this.$store.commit('updateRegistrationObject', this.obj)

        this.$emit('next')
      }
    },
  },
}
</script>

<style scoped>
.form-check-input {
  appearance: none;
  border-radius: 100%;
  height: 16px;
  width: 16px;
  border: 1px solid #fff;
  background-color: transparent;
  transition: all;
  transition-duration: 200ms;
  margin-top: 0px;
  margin-right: 8px;
  align-self: initial;
  float: left;
  cursor: pointer;
}

.form-check-input:checked {
  background-color: var(--input-color);
}

.form-check-input:focus {
  outline: none;
}

.left-align {
  text-align: left;
}

.form-radio label {
  margin-bottom: 0.5;
}
</style>
